import { ListItemButton, Theme, Tooltip } from "@mui/material";
import { SystemStyleObject } from "@mui/system";
import { NavigationItemIcon, NavigationItemLabel } from "@shared";

import { useTranslation } from "@/translations";

import { NavActionItem } from "./NavigationActionItem.types";

interface Props {
  navigationItem: NavActionItem;
  isSelected?: boolean;
  isCollapsed: boolean;
  onClick?: () => void;
  rootProps?: React.HTMLAttributes<HTMLElement>;
  sx: SystemStyleObject<Theme> | ((theme: Theme) => SystemStyleObject<Theme>);
}

export function NavigationActionItem({ navigationItem, isCollapsed, isSelected, onClick, rootProps, sx }: Props) {
  const { t } = useTranslation();
  const label = t(navigationItem.label);

  return (
    <Tooltip title={label} disableHoverListener={!isCollapsed} placement="right" arrow>
      <ListItemButton
        {...rootProps}
        selected={isSelected}
        aria-label={label}
        onClick={onClick}
        sx={[
          {
            height: 32,
            px: isCollapsed ? 0 : 2,
            py: 0.75,
            justifyContent: isCollapsed ? "center" : "flex-start",
            borderRadius: 0.5,

            "&:not(.Mui-selected) .MuiListItemIcon-root": {
              color: "action.active",
            },

            "&:hover:not(.Mui-selected)": {
              backgroundColor: "#fff",
              "& .MuiListItemIcon-root": {
                color: "text.primary",
              },
            },

            "&.Mui-selected": {
              backgroundColor: "#fff",
              "& .MuiListItemIcon-root": {
                color: "fsw.darkerblue",
              },
            },
          },
          sx,
          (theme) => ({
            ...(isCollapsed &&
              isSelected && {
                mx: -2,
                width: `calc(100% + ${theme.spacing(4)})`,
                borderRadius: 0,
                height: 48,
              }),
          }),
        ]}
      >
        <NavigationItemIcon icon={navigationItem.icon} isCollapsed={isCollapsed} />
        {!isCollapsed && <NavigationItemLabel label={navigationItem.label} />}
      </ListItemButton>
    </Tooltip>
  );
}
